import * as React from 'react';
import { Table } from "soprasteria-ui-library";
import { IReferralListSummary } from "../../../../models/IReferral";
import { Link } from 'react-router-dom';
import { REFERRAL, PATIENT } from '../../../../utils/RouteConstants';

interface IReferralUnderReviewSummaryTable {
    referrals: IReferralListSummary[];
}

export const ReferralUnderReviewSummaryTable: React.FunctionComponent<IReferralUnderReviewSummaryTable> = ({ referrals }) => {

    const renderTableLink = (linkText: string, patientGuidId: string, referralId: number) => {
        return <Link to={`/${PATIENT}/${patientGuidId}/${REFERRAL}/${referralId}`}>{linkText}</Link>
    }

    return (
        <Table hoverableRows>
            <thead>
                <tr>
                    <th>Remiss-ID</th>
                    <th>Remisstatus</th>
                    <th>Remissmottagare</th>
                    <th>Specialitet</th>
                </tr>
            </thead>
            <tbody>
                {
                    referrals.length > 0
                        ? referrals.map((referral, key) => {
                            return (
                                <tr className="clickable-row align-text-bottom" key={key} >
                                    <td className="table-data-link">{renderTableLink(referral.referralNumber.toString(), referral.patientGuidId, referral.referralId)}</td>
                                    <td className="table-data-link">{renderTableLink(referral.referralStatus, referral.patientGuidId, referral.referralId)}</td>
                                    <td className="table-data-link">{renderTableLink(referral.referralRecipentCareProviderName, referral.patientGuidId, referral.referralId)}</td>
                                    <td className="table-data-link">{renderTableLink(referral.specialty, referral.patientGuidId, referral.referralId)}</td>
                                </tr>
                            )
                        })
                        : <tr><td colSpan={4}>Det finns inga specialistremisser att visa</td></tr>
                }
            </tbody>
        </Table>
    )
}